import { Grid2 as Grid, Typography, Box, Chip } from "@mui/material";
import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { ContentAccordion, PhoneField } from "src/shared/components";
import { validatePhone } from "src/shared/utils/hookFormRules";
import { IPartnerFormValues } from "../../model/types";

export const ContactsShort: FC = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<IPartnerFormValues>();

  const hasErrors = !!errors?.partner?.phone || !!errors?.partner?.fax;

  return (
    <ContentAccordion
      title={
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Chip label="5" />
          <Typography
            component="span"
            color={hasErrors ? "error" : "grey.500"}
            sx={{ ml: 2 }}
          >
            Контакты
          </Typography>
        </Box>
      }
    >
      <Grid container spacing={6}>
        <Grid size={{ xs: 12, sm: 4, lg: 3 }}>
          <Controller
            control={control}
            name="partner.phone"
            render={({
              field: { ref, onChange, ...field },
              fieldState: { error },
            }) => (
              <PhoneField
                inputRef={ref}
                onChange={(_fieldValue, info) => {
                  onChange(info);
                }}
                {...field}
                label="Городской телефон"
                error={!!error}
                helperText={error?.message}
              />
            )}
            rules={{
              validate: (fieldValue) => validatePhone(fieldValue),
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4, lg: 3 }}>
          <Controller
            control={control}
            name="partner.fax"
            render={({
              field: { ref, onChange, ...field },
              fieldState: { error },
            }) => (
              <PhoneField
                inputRef={ref}
                onChange={(_fieldValue, info) => {
                  onChange(info);
                }}
                {...field}
                label="Факс"
                error={!!error}
                helperText={error?.message}
              />
            )}
            rules={{
              validate: (fieldValue) => validatePhone(fieldValue),
            }}
          />
        </Grid>
      </Grid>
    </ContentAccordion>
  );
};
